import { render, staticRenderFns } from "./templateForm.vue?vue&type=template&id=684152e4&scoped=true"
import script from "./templateForm.vue?vue&type=script&lang=js"
export * from "./templateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684152e4",
  null
  
)

export default component.exports